import { render } from "./AboutGame.vue?vue&type=template&id=31c6c96f"
import script from "./AboutGame.vue?vue&type=script&lang=js"
export * from "./AboutGame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__